import { Color } from '@zen/Styleguide';

const colorValues: string[] = Object.values(Color);

export const isColorBasic = (color: string): boolean => {
  return colorValues.includes(color);
};
